/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Space_Profile_Map_Drag_HintInputs */

const en_admin_space_profile_map_drag_hint = /** @type {(inputs: Admin_Space_Profile_Map_Drag_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag the map to adjust the pin`)
};

const de_admin_space_profile_map_drag_hint = /** @type {(inputs: Admin_Space_Profile_Map_Drag_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehe die Karte, um den Marker anzupassen`)
};

const es_admin_space_profile_map_drag_hint = /** @type {(inputs: Admin_Space_Profile_Map_Drag_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastra el mapa para ajustar el marcador`)
};

const fr_admin_space_profile_map_drag_hint = /** @type {(inputs: Admin_Space_Profile_Map_Drag_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faites glisser la carte pour ajuster le repère`)
};

const nl_admin_space_profile_map_drag_hint = /** @type {(inputs: Admin_Space_Profile_Map_Drag_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleep de kaart om de pin aan te passen`)
};

/** @type {(inputs: Admin_Space_Profile_Map_Drag_HintInputs) => LocalizedString} */
const it_admin_space_profile_map_drag_hint = en_admin_space_profile_map_drag_hint;

/** @type {(inputs: Admin_Space_Profile_Map_Drag_HintInputs) => LocalizedString} */
const pt_br2_admin_space_profile_map_drag_hint = en_admin_space_profile_map_drag_hint;

/** @type {(inputs: Admin_Space_Profile_Map_Drag_HintInputs) => LocalizedString} */
const pl_admin_space_profile_map_drag_hint = en_admin_space_profile_map_drag_hint;

/** @type {(inputs: Admin_Space_Profile_Map_Drag_HintInputs) => LocalizedString} */
const hu_admin_space_profile_map_drag_hint = en_admin_space_profile_map_drag_hint;

/** @type {(inputs: Admin_Space_Profile_Map_Drag_HintInputs) => LocalizedString} */
const ro_admin_space_profile_map_drag_hint = en_admin_space_profile_map_drag_hint;

/**
* | output |
* | --- |
* | "Drag the map to adjust the pin" |
*
* @param {Admin_Space_Profile_Map_Drag_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_space_profile_map_drag_hint = /** @type {((inputs?: Admin_Space_Profile_Map_Drag_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Space_Profile_Map_Drag_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_space_profile_map_drag_hint(inputs)
	if (locale === "de") return de_admin_space_profile_map_drag_hint(inputs)
	if (locale === "es") return es_admin_space_profile_map_drag_hint(inputs)
	if (locale === "fr") return fr_admin_space_profile_map_drag_hint(inputs)
	if (locale === "nl") return nl_admin_space_profile_map_drag_hint(inputs)
	if (locale === "it") return it_admin_space_profile_map_drag_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_space_profile_map_drag_hint(inputs)
	if (locale === "pl") return pl_admin_space_profile_map_drag_hint(inputs)
	if (locale === "hu") return hu_admin_space_profile_map_drag_hint(inputs)
	return ro_admin_space_profile_map_drag_hint(inputs)
});
export { admin_space_profile_map_drag_hint as "admin.space_profile_map.drag_hint" }